module.exports = __webpack_public_path__ + "img/google-sheet-logo.3cbe8b49.png";